import DashView from './components/DashVuetify.vue' // The Old Version was Dash.vue
import LoginView from './components/Login.vue'
import ClientLoginView from './components/ClientLogin.vue'
import SelectInstagram from './components/SelectInstagram.vue'
import PrivateRegister from './components/PrivateRegister.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import ResetPassword from './components/ResetPasswordPage.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import UserView from './components/views/User'
import ProfileView from './components/views/User/Profile.vue'
// import AccountDeleteRequestView from './components/views/Influencer/AccountDeleteRequests'
import UnApprovedUser from './components/views/User/UnApprovedUser.vue'
import InfluencerView from './components/views/Influencer'
import NonIMSInfluencerView from './components/views/Influencer/NonIMSLists.vue'
import SearchKeyword from './components/views/Influencer/SearchKeyword'
import SearchCreators from './components/views/Influencer/SearchCreators'
import CreatorConcept from './components/views/Pairing/CreatorConcept'
import CampaignPayoutListInternal from './components/views/Campaign/CampaignPayoutList.vue'
import CreateCampaignPayout from './components/views/Influencer/CreateCampaignPayout.vue'
import InstagramAuthView from './components/views/Instagram/handleAuth.vue'
import InstagramIntegrateView from './components/views/Instagram/handleIntegrate.vue'
import CompanyView from './components/views/Company'
import ClientView from './components/views/Client'
// import VendorCreationForm from './components/views/Client/VendorCreationForm'
import CreateClientFeedbackForm from './components/views/Client/CreateFeedbacksForm'
import ClientFeedbackForm from './components/views/Client/FeedbacksForm.vue'
import CreatorConceptForm from './components/views/Pairing/CreatorConceptForm/Form.vue'
import CreatorContentScripts from './components/views/Pairing/CreatorConceptForm/List.vue'
import CreateSigningForm from './components/views/Influencer/SigningForm/Form.vue'
import CampaignView from './components/views/Campaign'
import CampaignTimeline from './components/views/Campaign/Timeline'
import CampaignTimelineSummary from './components/views/Campaign/Timeline/Summary'
import StatisticsAnalysis from './components/views/Campaign/StatisticsAnalysis'
import DashboardView from './components/views/Dashboard.vue'
import CampaignBrief from './components/views/Campaign/CampaignBrief'
import CampaignReport from './components/views/Campaign/CampaignReport'
import CampaignsOverview from './components/views/Campaign/CampaignsOverview'
import AOKReport from './components/views/Campaign/AOKReport/index.vue'
import XeroHandleCallbackAuth from './components/views/Xero/XeroCallBackAuth'
import CampaignReportInternal from './components/views/Campaign/CampaignReportInternal.vue'
import InfluencerPosts from './components/views/Campaign/InfluencerPosts'
import InfluencerSocialData from './components/views/InfluencerSocialData'
import CampaignInvite from './components/views/Campaign/CampaignInvite/CampaignInvite'
import RateCard from './components/views/Campaign/RateCard'
import CampaignCompleted from './components/views/Campaign/CampaignCompleted'
import CampaignOngoing from './components/views/Campaign/CampaignOngoing'
import ContentAnalysis from './components/views/ContentAnalysis'
import InfluencerSearch from './components/views/InfluencerSearch'
import KeywordSearch from './components/views/Influencer/KeywordSearch'
import ExpressGatewayUsers from './components/views/Development/Express-Gateway/User'
import APITesting from './components/views/Development/API/Testing.vue'
import CreateDraftPostV2 from './components/views/Post/CreateDraftPostV2'
import PostView from './components/views/Post'
import PostViewClient from './components/views/Post/PostViewClient'
import PostViewInternal from './components/views/Post/PostViewInternal'
import PostDetail from './components/views/Post/PostDetail'
import SubmissionReview from './components/views/Post/SubmissionReview.vue'
import SubmitPostPayout from './components/views/Influencer/SubmitPostPayout'
// import AudienceInsightsView from './components/views/Influencer/AudienceInsightsForSubscriber.vue'
import PostViewCalender from './components/views/Post/CalenderViewPosts.vue'
import CreatePrivateLink from './components/views/User/CreatePrivateLink.vue'
// import RevenueRecognize from './components/views/Finance/RevenueRecognize.vue'
import MoneyOut from './components/views/Finance/MoneyOut.vue'
import MoneyIn from './components/views/Finance/MoneyIn.vue'
import PaymentConsolidation from './components/views/Finance/PaymentConsolidation.vue'
import ArchiveList from './components/views/Finance/ArchiveList.vue'
import CampaignInviteDetail from './components/views/Campaign/CampaignInvite/CampaignInviteDetail.vue'
// import CampaignInviteList from './components/views/Campaign/CampaignInvite/CampaignInviteList.vue'
// Import helper files
import config from '@/config'
// Pairing Influencer List
import InvoicesBriefConfirmation from './components/views/Campaign/PairingInfluencer/InvoicesBriefConfirmation.vue'
import PaymentConsolidationStatus from './components/views/Campaign/PairingInfluencer/PaymentConsolidationStatus.vue'
import InfluencerLists from './components/views/Campaign/PairingInfluencer/InfluencerLists/index.vue'
// Pairing Creators
// import PairedCreators from './components/views/Pairing/PairedCreators/index.vue'
// HTML Report Component
import CampaignSummaryReports from './components/reports'
import CampaignHtmlReport from './components/reports/HtmlReport.vue'
// CO_Dashboard Component
import CODashboard from './components/views/CODashboard/index.vue'
import Speed from './components/views/CODashboard/speed.vue'
import Quality from './components/views/CODashboard/quality.vue'
// Accured COGS
// import AccruedCogs from './components/views/Finance/AccruedCogs/index.vue'

// AM Dashboard Component
import AMDashboard from './components/views/AMDashboard/index.vue'
import AMSpeed from './components/views/AMDashboard/speed.vue'
import AMQuality from './components/views/AMDashboard/quality.vue'
import AMSpendRevenue from './components/views/AMDashboard/spendRevenue'
import COSpendRevenue from './components/views/CODashboard/spendRevenue'
import CampaignPayoutsReport from './components/views/Finance/payoutsReport'
// import InfluencerPayoutsReport from './components/views/Influencer/InfluencerPayoutsReport'
import CocreatingStatusReport from './components/views/Post/statusReport'
import DraftSubmissionReport from './components/views/Post/DraftSubmissionReport'
import CreateBrandSheetForm from './components/views/Campaign/BrandSheetForm'
import BrandSheetList from './components/views/Campaign/BrandSheetList'
import RateCardForm from './components/views/Influencer/RateCard/Form'
import JoinCommunityForm from './components/views/Influencer/JoinCommunity/Form'
import InfluencerRateCards from './components/views/Influencer/RateCard/index'
import JoinCommunity from './components/views/Influencer/JoinCommunity/index'
import UpcomingReviewMeeting from './components/views/Campaign/ReviewMeeting'
import CampaignMasterLists from './components/views/Campaign/MasterLists'
import COGSSummary from './components/views/Campaign/COGSSummary'
import CogsEstimate from './components/views/Finance/CogsEstimate'
import ProfitSummary from './components/views/Finance/ProfitSummary'
// Profile Tally
import ProfileTallyForm from './components/views/Influencer/ProfileTally/Form'

const userRoles = config.userRoles
const campaignStatus = config.campaignStatus
const campaignStatusDisplay = config.campaignStatusDisplay
const postStatus = config.postStatus
const postStatusDisplayInternal = config.postStatusDisplayInternal
const postStatusDisplayExternal = config.postStatusDisplayExternal

// Routes
const routes = [{
  path: '/login',
  name: 'Login',
  component: LoginView
},
{
  path: '/client-login',
  name: 'ClientLogin',
  component: ClientLoginView
},
{
  path: '/register',
  name: 'PrivateRegister',
  component: PrivateRegister
},
{
  path: '/forgot-password',
  name: 'ForgotPassword',
  component: ForgotPassword
},
/**
 * Aung
 * #NOTE: This is HTML Report for CS team
 * Free Acces route and free authenticate
 */
{
  path: '/reports/campaign/summary',
  name: 'CampaignSummaryReports',
  component: CampaignSummaryReports
},
/**
 * Kobe-styled HTML campaign report (new; sibling to summary above — does not
 * replace it). Standalone full-page route, same data source.
 */
{
  path: '/reports/campaign/html',
  name: 'CampaignHtmlReport',
  component: CampaignHtmlReport
},
/*
* Nyein
* This is free access route for client feedback form
*/
{
  path: config.CLIENT_FEEDBACK_FORM_URL + '/:campaignId',
  name: 'CreateClientFeedbackForm',
  component: CreateClientFeedbackForm
},
{
  path: config.BRAND_SHEET_FORM_URL + '/:campaignId',
  name: 'CreateBrandSheetForm',
  component: CreateBrandSheetForm
},
{
  path: config.RATE_CARD_FORM_URL,
  name: 'RateCardForm',
  component: RateCardForm
},
{
  path: config.JOIN_COMMUNITY_FORM_URL,
  name: 'JoinCommunityForm',
  component: JoinCommunityForm
},
{
  path: config.PROFILE_TALLY_FORM_URL,
  name: 'ProfileTallyForm',
  component: ProfileTallyForm
},
{
  path: config.SIGNING_IN_FORM_URL + '/:pairingID',
  name: 'CreateSigningForm',
  component: CreateSigningForm
},
{
  path: '/submit-post-payout',
  name: 'PayoutSubmission',
  component: SubmitPostPayout
},
{
  path: '/developer/express-gateway/users',
  name: 'ExpressGatewayUsers',
  component: ExpressGatewayUsers,
  meta: {
    description: 'Overview of environment',
    requiresAuth: true,
    allow: [
      userRoles.SUPER_ADMIN_HIGH
    ]
  }
},
{
  path: '/developer/api/testing',
  name: 'APITesting',
  component: APITesting,
  meta: {
    description: 'Overview of environment',
    requiresAuth: true,
    allow: [
      userRoles.SUPER_ADMIN_HIGH
    ]
  }
},
{
  path: '/reset_password/:email/:token',
  name: 'ResetPassword',
  component: ResetPassword
},
{
  path: '/instagrams/handleAuth',
  name: 'InstagramLogin',
  component: InstagramAuthView
},
{
  path: '/instagrams/handleIntegrate',
  name: 'InstagramIntegrate',
  component: InstagramIntegrateView
},
{
  path: '/xero/handleAuth',
  name: 'XeroHandleCallbackAuth',
  component: XeroHandleCallbackAuth,
  meta: {
    description: 'Xero Integration',
    requiresAuth: true,
    allow: [
      userRoles.SUPER_ADMIN_HIGH,
      userRoles.SUPER_ADMIN_LOW,
      userRoles.FINANCE
    ]
  }
},
{
  path: '/influencers/content-storyboard/:id',
  component: CreatorConceptForm,
  name: 'CreatorConceptForm'
},
{
  path: '/',
  component: DashView,
  children: [{
    path: 'dashboard',
    alias: '',
    component: DashboardView,
    name: 'Dashboard',
    meta: {
      description: 'Overview of environment',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.CLIENT,
        userRoles.INFLUENCER,
        userRoles.FINANCE
      ]
    }
  },
  // Aung added CC dashboard
  {
    path: 'co/dashboard',
    alias: 'CC Dashboard',
    component: CODashboard,
    name: 'co-dashboard',
    meta: {
      description: 'Overview of CC environment',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  {
    path: 'co/dashboard/speed',
    alias: '',
    component: Speed,
    name: 'co-speed',
    meta: {
      description: 'Detail fo CC Speed Graph',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  {
    path: 'co/dashboard/quality',
    alias: '',
    component: Quality,
    name: 'CO-Quality',
    meta: {
      description: 'Detail for CC Quality Graph',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  {
    path: 'co/dashboard/spend/revenue',
    alias: '',
    component: COSpendRevenue,
    name: 'co-spend-revenue',
    meta: {
      description: 'Detail for CC Spend Revenue Graph',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  // Aung added AM dashboard
  {
    path: 'am/dashboard',
    alias: 'AM Dashboard',
    component: AMDashboard,
    name: 'am-dashboard',
    meta: {
      description: 'Overview of AM environment',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER
      ]
    }
  },
  {
    path: 'am/dashboard/speed',
    alias: '',
    component: AMSpeed,
    name: 'am-speed',
    meta: {
      description: 'Detail fo AM Speed Graph',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER
      ]
    }
  },
  {
    path: 'am/dashboard/quality',
    alias: '',
    component: AMQuality,
    name: 'AM-Quality',
    meta: {
      description: 'Detail for AM Quality Graph',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER
      ]
    }
  },
  {
    path: 'am/dashboard/spend/revenue',
    alias: '',
    component: AMSpendRevenue,
    name: 'am-spend-revenue',
    meta: {
      description: 'Detail for AM Spend Revenue Graph',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER
      ]
    }
  },
  {
    path: 'campaign-report-internal',
    alias: '',
    component: CampaignReportInternal,
    name: 'Campaign Report Internal',
    meta: {
      description: 'Generate Campaign Report',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'services/influencer-lists',
    component: InfluencerLists,
    name: 'Influencer Lists',
    meta: {
      description: 'Influencer Lists',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.FINANCE, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER]
    }
  },
  {
    path: '/facebook/auth',
    name: 'FacebookAuth',
    component: SelectInstagram
  },
  { path: 'users',
    component: UserView,
    name: 'Users',
    meta: {
      description: 'User list',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.FINANCE, userRoles.ACCOUNT_MANAGER, userRoles.AD_STRATEGIST]
    }
  },
  {
    path: 'users/un-verified',
    component: UnApprovedUser,
    name: 'New Signups',
    meta: {
      description: '',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER
      ]
    }
  },
  {
    path: 'users/create-link',
    component: CreatePrivateLink,
    name: 'Invite an Influencer to IMS',
    meta: {
      description: '',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  // { path: 'influencer-delete-requests',
  //   component: AccountDeleteRequestView,
  //   name: 'Influencer Delete Requests',
  //   meta: {
  //     description: 'Influencer Delete Requests list',
  //     requiresAuth: true,
  //     allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW]
  //   }
  // },
  {
    path: 'content-analysis',
    alias: '',
    component: ContentAnalysis,
    name: 'Content Analysis',
    meta: {
      description: 'Analyse the Post Content',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'search-influencers',
    component: InfluencerSearch,
    name: 'Influencer Search by NLU/Computer Vision',
    meta: {
      description: 'Influencer Search for Kobe Company only',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'profile',
    component: ProfileView,
    name: 'Profile',
    meta: {
      description: 'Profile',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  },
  {
    path: 'submit-post-payout-creator',
    component: SubmitPostPayout,
    name: 'Payout Submission',
    meta: {
      description: 'Submit payout for this post',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  },
  {
    path: '/content-storyboard-list',
    component: CreatorContentScripts,
    name: 'Content Storyboards',
    meta: {
      description: 'Content Storyboard',
      requiresAuth: true,
      allow: [
        userRoles.INFLUENCER
      ]
    }
  },
  {
    path: 'submitCampaignPayouts',
    component: CreateCampaignPayout,
    name: 'Submit Campaign Payout',
    meta: {
      description: 'Submit new campaign payout',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  },
  {
    path: 'v2/submit-draft-post',
    component: CreateDraftPostV2,
    name: 'Submit Draft Post',
    meta: {
      description: 'Submit a draft post for the campaign',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  },
  // Disable the Audience Insights for Influencers upon Request
  // {
  //   path: 'my-audience-insights',
  //   component: AudienceInsightsView,
  //   name: 'Audience Insights',
  //   meta: {
  //     description: 'Your follower insights',
  //     requiresAuth: true,
  //     allow: [userRoles.INFLUENCER]
  //   }
  // },
  {
    path: 'influencers',
    component: InfluencerView,
    name: 'IMS Influencers',
    meta: {
      description: 'Influencer list',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        // userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'all-influencers',
    component: NonIMSInfluencerView,
    name: 'All Influencers',
    meta: {
      description: 'All Influencer list',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        // userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE,
        userRoles.MARKETING
      ]
    }
  },
  {
    path: 'content/search',
    component: SearchKeyword,
    name: 'Content Search',
    meta: {
      description: 'Search Influencers by keywords in posts',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'influencers/discovery',
    component: KeywordSearch,
    name: 'Creator Discovery',
    meta: {
      description: 'Search Influencers by Keyword',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  // {
  //   path: 'paired/creators',
  //   component: PairedCreators,
  //   name: 'Paired Creators',
  //   meta: {
  //     description: 'Paired Creators',
  //     requiresAuth: true,
  //     allow: [
  //       userRoles.SUPER_ADMIN_HIGH,
  //       userRoles.SUPER_ADMIN_LOW,
  //       userRoles.COMPANY_ADMIN_HIGH,
  //       userRoles.COMPANY_ADMIN_LOW,
  //       userRoles.AD_STRATEGIST,
  //       userRoles.ACCOUNT_MANAGER,
  //       userRoles.FINANCE
  //     ]
  //   }
  // },
  {
    path: 'creators/search',
    component: SearchCreators,
    name: 'Creators Search',
    meta: {
      description: 'Creators Search',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'content-storyboard',
    component: CreatorConcept,
    name: 'Content Storyboard',
    meta: {
      description: 'Content Storyboard',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE,
        userRoles.CLIENT
      ]
    }
  },
  {
    path: 'influencers/social-data',
    component: InfluencerSocialData,
    name: 'Influencer Audience Data',
    meta: {
      description: 'Influencer Audience Data',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'companies',
    component: CompanyView,
    name: 'Companies',
    meta: {
      description: 'Company list',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW]
    }
  },
  {
    path: 'clients',
    component: ClientView,
    name: 'Clients',
    meta: {
      description: 'Client list',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  // {
  //   path: 'client/vendor-creation-form',
  //   component: VendorCreationForm,
  //   name: 'Vendor Creation Form',
  //   meta: {
  //     description: 'Vendor Creation Form for Clients',
  //     requiresAuth: true,
  //     allow: [
  //       userRoles.CLIENT
  //     ]
  //   }
  // },
  {
    path: config.CLIENT_FEEDBACK_FORM_URL,
    component: ClientFeedbackForm,
    name: 'Client Feedbacks',
    meta: {
      description: 'Client Feedbacks',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: config.CLIENT_FEEDBACK_FORM_URL + '/archive/lists',
    component: ClientFeedbackForm,
    name: 'Archived Client Feedbacks',
    meta: {
      description: 'Archived Client Feedbacks',
      requiresAuth: true,
      archive: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  {
    path: 'campaignPayoutsInternal',
    component: CampaignPayoutListInternal,
    name: 'Creator Stats & Rating',
    meta: {
      description: 'Campaign Payout from Influencers',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'payouts-report',
    alias: '',
    component: CampaignPayoutsReport,
    name: 'Payouts Report',
    meta: {
      description: 'Campaign Payouts Report',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  // {
  //   path: 'influencer-payouts-report',
  //   alias: '',
  //   component: InfluencerPayoutsReport,
  //   name: 'Payouts Report',
  //   meta: {
  //     description: 'Payouts Report',
  //     requiresAuth: true,
  //     allow: [
  //       userRoles.INFLUENCER
  //     ]
  //   }
  // },
  {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.DRAFT]['url'],
    component: CampaignView,
    name: campaignStatusDisplay[campaignStatus.DRAFT]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.DRAFT,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.DRAFT]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.DRAFT]['permissions']
    }
  },
  {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['url'],
    component: CampaignView,
    name: campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.PENDING_CLIENT_APPROVAL,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.PENDING_CLIENT_APPROVAL]['permissions']
    }
  },
  {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.PAIRING_BRIEF]['url'],
    component: CampaignView,
    name: campaignStatusDisplay[campaignStatus.PAIRING_BRIEF]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.PAIRING_BRIEF,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.PAIRING_BRIEF]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.PAIRING_BRIEF]['permissions']
    }
  },
  {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['url'],
    component: CampaignView,
    name: campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.PAIRING_INFLUENCER,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.PAIRING_INFLUENCER]['permissions']
    }
  },
  {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.RATE_CARD]['url'],
    component: RateCard,
    name: campaignStatusDisplay[campaignStatus.RATE_CARD]['display'] + ' Requests',
    meta: {
      campaignStatus: campaignStatus.RATE_CARD,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.RATE_CARD]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.RATE_CARD]['permissions']
    }
  },
  {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.ONGOING]['url'],
    component: CampaignView,
    name: campaignStatusDisplay[campaignStatus.ONGOING]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.ONGOING,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.ONGOING]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.ONGOING]['permissions']
    }
  },
  {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.REVIEW]['url'],
    component: CampaignView,
    name: campaignStatusDisplay[campaignStatus.REVIEW]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.REVIEW,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.REVIEW]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.REVIEW]['permissions']
    }
  },
  {
    path: 'campaigns/' + campaignStatusDisplay[campaignStatus.COMPLETE]['url'],
    component: CampaignView,
    name: campaignStatusDisplay[campaignStatus.COMPLETE]['display'] + ' campaigns',
    meta: {
      campaignStatus: campaignStatus.COMPLETE,
      description: 'Campaigns ' + campaignStatusDisplay[campaignStatus.COMPLETE]['url'],
      requiresAuth: true,
      allow: campaignStatusDisplay[campaignStatus.COMPLETE]['permissions']
    }
  },
  {
    path: 'campaigns/all',
    component: CampaignView,
    name: 'All Campaigns Report',
    meta: {
      campaignStatus: -1,
      description: 'Campaigns all',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE,
        userRoles.MARKETING
      ]
    }
  },
  {
    path: 'aok-report',
    component: AOKReport,
    name: 'AOK Report',
    meta: {
      description: 'AOK Report',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'clients/campaigns',
    component: CampaignBrief,
    name: 'Campaigns',
    meta: {
      description: 'Campaigns',
      requiresAuth: true,
      allow: [userRoles.CLIENT]
    }
  },
  {
    path: 'campaigns/:campaignID/invitation',
    component: CampaignInviteDetail,
    name: 'Campaign Invitation',
    meta: {
      description: 'Campaign Invitation',
      requiresAuth: true,
      allow: [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE, userRoles.INFLUENCER]
    }
  },
  {
    path: 'campaigns/influencer-posts',
    component: InfluencerPosts,
    name: 'influencer-posts',
    meta: {
      description: 'Influencer Posts',
      requiresAuth: true,
      allow: [userRoles.CLIENT]
    }
  },
  {
    path: 'clients/campaigns-reports',
    component: CampaignReport,
    name: 'Campaign Report',
    meta: {
      description: 'Campaign Reports',
      requiresAuth: true,
      allow: [userRoles.CLIENT]
    }
  },
  {
    path: 'campaigns/overview',
    component: CampaignsOverview,
    name: 'Campaign Overview',
    meta: {
      description: 'Campaign Overview',
      requiresAuth: true,
      allow: [userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE]
    }
  },
  {
    path: 'campaigns/:campaignID/invite-influencer',
    component: CampaignInvite,
    name: 'campaign-invites',
    meta: {
      description: 'Campaign Invites',
      requiresAuth: true,
      allow: [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.AD_STRATEGIST, userRoles.ACCOUNT_MANAGER, userRoles.FINANCE]
    }
  },
  {
    path: 'campaigns/ongoing',
    component: CampaignOngoing,
    name: 'ongoing-campaigns',
    meta: {
      description: 'Ongoing Campaigns',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  },
  // {
  //   path: 'campaigns/invited',
  //   component: CampaignInviteList,
  //   name: 'Campaigns Invited',
  //   meta: {
  //     description: 'Invited campaigns',
  //     requiresAuth: true,
  //     allow: [userRoles.INFLUENCER]
  //   }
  // },
  {
    path: 'campaigns/influencer-completed',
    component: CampaignCompleted,
    name: 'completed-campaigns',
    meta: {
      description: 'Completed Campaigns',
      requiresAuth: true,
      allow: [userRoles.INFLUENCER]
    }
  },
  {
    path: 'influencers/invoices-brief-confirmation',
    name: 'Invoices & Brief Confirmation',
    component: InvoicesBriefConfirmation,
    meta: {
      description: 'Invoices & Brief Confirmation',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.FINANCE,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER
      ]
    }
  },
  {
    path: 'clients/payments',
    component: require('./components/views/Client/Payment'),
    name: 'Client payments',
    meta: {
      description: 'Client Payment',
      requiresAuth: true,
      allow: [userRoles.CLIENT]
    }
  },
  {
    path: 'payments-from-clients',
    component: require('./components/views/Client/AdminPayment'),
    name: 'Payments from Clients',
    meta: {
      description: 'Payments from Clients',
      requiresAuth: true,
      allow: [userRoles.COMPANY_ADMIN_HIGH, userRoles.COMPANY_ADMIN_LOW, userRoles.SUPER_ADMIN_HIGH, userRoles.SUPER_ADMIN_LOW, userRoles.FINANCE]
    }
  },
  {
    path: 'posts/' + postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['url'],
    component: PostView,
    name: postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['display'],
    meta: {
      postStatus: postStatus.AD_STRATEGIST_PENDING,
      description: 'Posts ' + postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['url'],
      requiresAuth: true,
      allow: postStatusDisplayExternal[postStatus.AD_STRATEGIST_PENDING]['permissions']
    }
  },
  {
    path: 'posts/' + postStatusDisplayExternal[postStatus.CLIENT_PENDING]['url'],
    component: PostView,
    name: postStatusDisplayExternal[postStatus.CLIENT_PENDING]['display'],
    meta: {
      postStatus: postStatus.CLIENT_PENDING,
      description: 'Posts ' + postStatusDisplayExternal[postStatus.CLIENT_PENDING]['url'],
      requiresAuth: true,
      allow: postStatusDisplayExternal[postStatus.CLIENT_PENDING]['permissions']
    }
  },
  {
    path: 'posts/' + postStatusDisplayExternal[postStatus.APPROVE]['url'],
    component: PostView,
    name: postStatusDisplayExternal[postStatus.APPROVE]['display'],
    meta: {
      postStatus: postStatus.APPROVE,
      description: 'Posts ' + postStatusDisplayExternal[postStatus.APPROVE]['url'],
      requiresAuth: true,
      allow: postStatusDisplayExternal[postStatus.APPROVE]['permissions']
    }
  },
  /**
   * Aung
   * Influencer approved post view
   */
  {
    path: 'posts/view/:postId',
    component: PostDetail,
    name: 'Post View',
    meta: {
      postStatus: postStatus.APPROVE,
      description: 'Posts View',
      requiresAuth: true,
      allow: [
        config.userRoles.SUPER_ADMIN_HIGH,
        config.userRoles.SUPER_ADMIN_LOW,
        config.userRoles.COMPANY_ADMIN_HIGH,
        config.userRoles.COMPANY_ADMIN_LOW,
        config.userRoles.AD_STRATEGIST,
        config.userRoles.ACCOUNT_MANAGER,
        config.userRoles.CLIENT,
        config.userRoles.INFLUENCER,
        config.userRoles.FINANCE
      ]
    }
  },
  {
    path: 'posts/' + postStatusDisplayExternal[postStatus.LIVE]['url'],
    component: PostView,
    name: postStatusDisplayExternal[postStatus.LIVE]['display'],
    meta: {
      postStatus: postStatus.LIVE,
      description: 'Posts ' + postStatusDisplayExternal[postStatus.LIVE]['url'],
      requiresAuth: true,
      allow: postStatusDisplayExternal[postStatus.LIVE]['permissions']
    }
  },
  {
    path: 'clients/posts',
    component: PostViewClient,
    name: 'Posts',
    meta: {
      description: 'Posts',
      requiresAuth: true,
      allow: [userRoles.CLIENT]
    }
  },
  // Internally use
  {
    path: 'posts/' + postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['url'],
    component: PostViewInternal,
    name: postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.AD_STRATEGIST_PENDING,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['url'],
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['permissions']
    }
  },
  {
    path: 'posts/' + postStatusDisplayInternal[postStatus.CLIENT_PENDING]['url'],
    component: PostViewInternal,
    name: postStatusDisplayInternal[postStatus.CLIENT_PENDING]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.CLIENT_PENDING,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.CLIENT_PENDING]['url'],
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.CLIENT_PENDING]['permissions']
    }
  },
  {
    path: 'posts/' + postStatusDisplayInternal[postStatus.APPROVE]['url'],
    component: PostViewInternal,
    name: postStatusDisplayInternal[postStatus.APPROVE]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.APPROVE,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.APPROVE]['url'],
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.APPROVE]['permissions']
    }
  },
  {
    path: 'posts/' + postStatusDisplayInternal[postStatus.LIVE]['url'],
    component: PostViewInternal,
    name: postStatusDisplayInternal[postStatus.LIVE]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.LIVE,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.LIVE]['url'],
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.LIVE]['permissions']
    }
  },
  {
    path: 'posts/' + postStatusDisplayInternal[postStatus.COMPLETE]['url'],
    component: PostViewInternal,
    name: postStatusDisplayInternal[postStatus.COMPLETE]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.COMPLETE,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.COMPLETE]['url'],
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.COMPLETE]['permissions']
    }
  },
  {
    path: 'posts/' + postStatusDisplayInternal[postStatus.ARCHIVE]['url'],
    component: PostViewInternal,
    name: postStatusDisplayInternal[postStatus.ARCHIVE]['display'] + ' Internal',
    meta: {
      postStatus: postStatus.ARCHIVE,
      description: 'Posts ' + postStatusDisplayInternal[postStatus.ARCHIVE]['url'],
      archive: true,
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.ARCHIVE]['permissions']
    }
  },
  {
    path: 'posts/internal/all-posts',
    component: PostViewInternal,
    name: 'All Posts',
    meta: {
      postStatus: -1,
      description: 'All Posts',
      archive: true,
      requiresAuth: true,
      allow: postStatusDisplayInternal[postStatus.AD_STRATEGIST_PENDING]['permissions']
    }
  },
  {
    path: 'posts/submission-review',
    component: SubmissionReview,
    name: 'posts-submission-review',
    meta: {
      description: 'Report Abuse or Rate Influencer regarding the post',
      requiresAuth: true,
      allow: [config.userRoles.CLIENT]
    }
  },
  {
    path: 'stats-collection-calendar',
    component: PostViewCalender,
    name: 'Stats Collection Calendar',
    meta: {
      description: 'Stats Collection Calendar',
      requiresAuth: true,
      allow: [
        config.userRoles.SUPER_ADMIN_HIGH,
        config.userRoles.SUPER_ADMIN_LOW,
        config.userRoles.COMPANY_ADMIN_HIGH,
        config.userRoles.COMPANY_ADMIN_LOW,
        config.userRoles.AD_STRATEGIST,
        config.userRoles.ACCOUNT_MANAGER,
        config.userRoles.CLIENT,
        config.userRoles.INFLUENCER,
        config.userRoles.FINANCE
      ]
    }
  },
  {
    path: 'clients/posts-approved-calender',
    component: PostViewCalender,
    name: 'Post Calendar',
    meta: {
      description: 'Approved Posts in calender View',
      requiresAuth: true,
      allow: [
        config.userRoles.CLIENT
      ]
    }
  },
  /**
   * Nyein - co-creating status report
   */
  {
    path: 'posts/co-creating/status-report',
    alias: '',
    component: CocreatingStatusReport,
    name: 'Co-creating Status Report',
    meta: {
      description: 'Co-creating Status Report',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  /**
   * Nyein - draft submissions report
   */
  {
    path: 'posts/draft-submissions-report',
    alias: '',
    component: DraftSubmissionReport,
    name: 'Draft Submissions Report',
    meta: {
      description: 'Draft Submissions Report',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'finance/revenue-recognize',
    component: CampaignsOverview,
    name: 'Revenue Recognize',
    meta: {
      description: 'Revenue Recognize',
      requiresAuth: true,
      allow: [
        config.userRoles.SUPER_ADMIN_HIGH,
        config.userRoles.SUPER_ADMIN_LOW,
        config.userRoles.ACCOUNT_MANAGER,
        // config.userRoles.COMPANY_ADMIN_HIGH,
        // config.userRoles.COMPANY_ADMIN_LOW,
        config.userRoles.FINANCE
      ]
    }
  },
  {
    path: 'finance/money-out',
    component: MoneyOut,
    name: 'Payout Recognize',
    meta: {
      description: 'Revenue Recognize',
      requiresAuth: true,
      allow: [
        config.userRoles.SUPER_ADMIN_HIGH,
        config.userRoles.SUPER_ADMIN_LOW,
        config.userRoles.AD_STRATEGIST,
        // config.userRoles.COMPANY_ADMIN_HIGH,
        // config.userRoles.COMPANY_ADMIN_LOW,
        config.userRoles.FINANCE
      ]
    }
  },
  {
    path: 'finance/money-in',
    component: MoneyIn,
    name: 'Payments/Receipts Recognize',
    meta: {
      description: 'Payments/Receipts Recognize',
      requiresAuth: true,
      allow: [
        config.userRoles.SUPER_ADMIN_HIGH,
        config.userRoles.SUPER_ADMIN_LOW,
        config.userRoles.ACCOUNT_MANAGER,
        // config.userRoles.COMPANY_ADMIN_HIGH,
        // config.userRoles.COMPANY_ADMIN_LOW,
        config.userRoles.FINANCE
      ]
    }
  },
  {
    path: 'finance/payment-consolidation',
    component: PaymentConsolidation,
    name: 'Payment Consolidation',
    meta: {
      description: 'Payment Consolidation',
      requiresAuth: true,
      allow: [
        config.userRoles.SUPER_ADMIN_HIGH,
        config.userRoles.SUPER_ADMIN_LOW,
        config.userRoles.AD_STRATEGIST,
        config.userRoles.ACCOUNT_MANAGER,
        // config.userRoles.COMPANY_ADMIN_HIGH,
        // config.userRoles.COMPANY_ADMIN_LOW,
        config.userRoles.FINANCE
      ]
    }
  },
  {
    path: 'finance/payment-consolidation/status',
    name: 'Payment Consolidation Status',
    component: PaymentConsolidationStatus,
    meta: {
      description: 'Payment Consolidation Status',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: 'finance/payment-consolidation/archive',
    component: ArchiveList,
    name: 'Archived Payment Consolidation',
    meta: {
      description: 'Archived Payment Consolidation',
      requiresAuth: true,
      allow: [
        config.userRoles.SUPER_ADMIN_HIGH,
        config.userRoles.SUPER_ADMIN_LOW,
        config.userRoles.AD_STRATEGIST,
        // config.userRoles.COMPANY_ADMIN_HIGH,
        // config.userRoles.COMPANY_ADMIN_LOW,
        config.userRoles.FINANCE
      ]
    }
  },
  // {
  //   path: 'finance/accrued-cogs',
  //   name: 'Accrued COGS',
  //   component: AccruedCogs,
  //   meta: {
  //     description: 'Accrued COGS',
  //     requiresAuth: true,
  //     allow: [
  //       userRoles.SUPER_ADMIN_HIGH,
  //       userRoles.SUPER_ADMIN_LOW,
  //       userRoles.COMPANY_ADMIN_HIGH,
  //       userRoles.AD_STRATEGIST,
  //       userRoles.ACCOUNT_MANAGER,
  //       userRoles.FINANCE
  //     ]
  //   }
  // },
  {
    path: config.BRAND_SHEET_FORM_URL,
    component: BrandSheetList,
    name: 'Brand Fact Sheet',
    meta: {
      description: 'Brand Fact Sheet',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  {
    path: '/influencers/rate-cards',
    component: InfluencerRateCards,
    name: 'Ratecard Forms',
    meta: {
      description: 'Rate Cards',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST,
        userRoles.MARKETING
      ]
    }
  },
  {
    path: '/influencers/join-community',
    component: JoinCommunity,
    name: 'Creator Community Forms',
    meta: {
      description: 'Join Community',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST,
        userRoles.MARKETING
      ]
    }
  },
  {
    path: '/campaigns/archive',
    component: CampaignView,
    name: 'Archived Campaigns',
    meta: {
      campaignStatus: -1,
      archive: true,
      description: 'Archived Campaigns',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  {
    path: '/campaigns/timeline',
    component: CampaignTimeline,
    name: 'Campaign Timeline',
    meta: {
      description: 'Campaign Timeline',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  {
    path: '/campaigns/timeline/summary',
    component: CampaignTimelineSummary,
    name: 'Campaign Timeline Summary',
    meta: {
      description: 'Campaign Timeline Summary',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  {
    path: '/campaigns/statistics/analysis',
    component: StatisticsAnalysis,
    name: 'Stats Analysis',
    meta: {
      description: 'Stats Analysis',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: '/campaigns/upcoming-review-meetings',
    component: UpcomingReviewMeeting,
    name: 'Upcoming Review Meetings',
    meta: {
      description: 'Upcoming Review Meetings',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST
      ]
    }
  },
  {
    path: '/campaigns/campaign-cogs',
    component: COGSSummary,
    name: 'Campaign COGS',
    meta: {
      description: 'Campaign COGS',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: '/finance/cogs-estimation',
    component: CogsEstimate,
    name: 'COGS Estimation',
    meta: {
      description: 'COGS Estimation',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.ACCOUNT_MANAGER,
        userRoles.AD_STRATEGIST,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: '/finance/profit-summary',
    component: ProfitSummary,
    name: 'Profit Summary',
    meta: {
      description: 'Profit Summary',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.FINANCE
      ]
    }
  },
  {
    path: '/finance/masterlist',
    component: CampaignMasterLists,
    name: 'Masterlist',
    meta: {
      description: 'Masterlist',
      requiresAuth: true,
      allow: [
        userRoles.SUPER_ADMIN_HIGH,
        userRoles.SUPER_ADMIN_LOW,
        userRoles.COMPANY_ADMIN_HIGH,
        userRoles.COMPANY_ADMIN_LOW,
        userRoles.AD_STRATEGIST,
        userRoles.ACCOUNT_MANAGER,
        userRoles.FINANCE
      ]
    }
  }
  ]
},
{
  // not found handler
  path: '*',
  component: NotFoundView
}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js